import React from 'react';
export function FinalCTASection() {
  return <section className="px-5 py-10 pb-24 max-w-[640px] mx-auto text-center" data-id="element-47">
      <h2 className="text-[clamp(22px,5vw,32px)] font-extrabold leading-tight" data-id="element-48">
        ¿Seguirás adivinando
        <br data-id="element-49" />o empezarás a saber?
      </h2>

      <p className="text-[var(--muted)] text-[17px] my-3.5 mb-7" data-id="element-50">
        El sistema es de $17. Una relación equivocada te cuesta mucho más.
      </p>

      <a href="#precio" className="block bg-[var(--red2)] text-white text-center py-4 px-6 rounded-xl font-bold text-base tracking-wider max-w-[400px] mx-auto hover:bg-[#a82040] transition-colors" data-id="element-51">
        ACTIVAR MI CÓDIGO ROJO →
      </a>

      <p className="text-[var(--muted)] text-xs mt-3" data-id="element-52">
        🛡️ Garantía de 30 días · Acceso instantáneo
      </p>
    </section>;
}